/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    email: string;
}

export function AccountFromJSON(json: any): Account {
    return {
        'accountId': json['accountId'],
        'name': json['name'],
        'email': json['email'],
    };
}

export function AccountToJSON(value?: Account): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'accountId': value.accountId,
        'name': value.name,
        'email': value.email,
    };
}


